<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Agenda"
      Pagina="Agenda"
    ></app-breadcrumb>
    <div class="row">
        <div class="row" style="padding: 20px 20px 0px 20px;">
          <div class="col-md-3">
            <button class="btn btn-primary" style="cursor: pointer;" (click)="abrirModal()">Novo compromisso</button>
          </div>
          <div class="col-md-9"></div>
          <hr style="margin-top: 20px;">
        </div>
        <app-calendario [titulo]="'Minha Agenda'" (diaClicado)="abrirModal($event)"></app-calendario>
        <app-novo-compromisso
          (atualizarListaDiario)="atualizarListaDiario()"
          ></app-novo-compromisso>
    </div>
  </section>
</div>


